import { mapGetters, mapActions } from "vuex";
import { isObjectEmpty } from "@/utils";
export default {
  name: "AccountsMixin",
  computed: {
    ...mapGetters(["accountByProviderGet", "workspaceNameById", "accountAdvertisingByDSPAgencyGet"])
  },
  methods: {
    ...mapActions(["accountList", "workspaceList", "accountProfileList"]),
    amazonAdvertisingProfilesForAccount(account) {
      return this.accountAdvertisingBySellerIdGet(account.account_id).filter(item => item.account_provider === 'Amazon Advertising');
    },
    amazonDSPAdvertiserProfilesForAccount(account) {
      return this.accountAdvertisingBySellerIdGet(account.account_id).filter(item => item.account_provider === 'Amazon DSP Advertising' && item?.account_type == 'advertiser');
    },
    amazonDSPAgencyProfilesForAccount(account) {
      return this.accountAdvertisingBySellerIdGet(account.account_id).filter(item => item.account_provider === 'Amazon DSP Advertising' && item?.account_type == 'agency');
    },
    amazonDSPAdvertiserProfilesForAgencyProfile(account) {
      return this.accountAdvertisingByDSPAgencyGet(account.account_id).filter(item => item.account_provider === 'Amazon DSP Advertising' && item?.account_type == 'advertiser');
    },
    async getOmnyAccountSellers() {
      let perf = [];
      perf.push(performance.now());
      await this.workspaceList({});
      await this.accountList({});
      const sellerCentralAccounts = this.accountByProviderGet("Amazon Seller Central");
      const vendorCentralAccounts = this.accountByProviderGet("Amazon Vendor Central");
      perf.push(performance.now());
      //console.log(`[Perf][getOmnyAccountSeller]: ${(perf[1]-perf[0])/1000} s`);
      return [...sellerCentralAccounts, ...vendorCentralAccounts].map(account => {
        return {
          id: account.account_id,
          account_id: account.account_id,
          region: account.region,
          account_provider: account.account_provider,
          name: account.account_name || this.workspaceNameById(account.workspace_id)
        };
      });
    },
    async getOmnySellerCentralAccounts() {
      await this.workspaceList({});
      await this.accountList({});
      const sellerCentralAccounts = this.accountByProviderGet("Amazon Seller Central");
      return sellerCentralAccounts.map(account => {
        return {
          id: account.account_id,
          account_id: account.account_id,
          region: account.region,
          name: account.account_name || this.workspaceNameById(account.workspace_id)
        };
      });
    },
    async getOmnyAccountProfileIds(seller_ids = []) {
      await this.accountProfileList({
        seller_id: seller_ids.map(seller => seller.id)
      });
    },
    throwIfError(result) {
      if (result?.status == "error" || isObjectEmpty(result) || !result) {
        throw result;
      }
    },
    allAccountsInFilterListBelongToWorkspace(filter_list) {
      //pass
    },
    isSellerCentralAccount(account_id) {
      const sellerAccounts = this.accountByProviderGet("Amazon Seller Central");
      return sellerAccounts.some(account => account.account_id?.toString() === account_id?.toString());
    },
    isVendorCentralAccount(account_id) {
      const sellerAccounts = this.accountByProviderGet("Amazon Vendor Central");
      return sellerAccounts.some(account => account.account_id?.toString() === account_id?.toString());
    },
    isAnyDSPAccountPresent() {
      const dspAccounts = this.accountByProviderGet("Amazon DSP Advertising");
      return dspAccounts?.length ? true : false;
    },
    announceNoAccounts() {
      window.$bus.trigger("showInfo", {
        message: "No accounts available on the platform at the moment.",
        visible: true,
        delay: 50
      });
    }
  }
};